AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Models", "Base");

AoPS.Ebooks.Models.Base = (function (EbkMBase) {
	// Dependencies
	var Ajax = AoPS.Ajax;
	var BbExtras = AoPS.BackboneExtras;
	var LoadUtils = AoPS.LoadUtils;
	var bootstrap_data = AoPS.bootstrap_data || {};

	// TODO: Where to put this? How to avoid duplicating with EbookUtils?
	EbkMBase.HARD_HTML = '<span class="ebk-hard-symbol">&#9733;</span>';

	EbkMBase.ajax = new Ajax.ScriptRunner("/m/ebooks/ajax.php", {
		timeout: bootstrap_data.ebk_is_admin ? 59000 : 20000,
	});

	var base_model = {};
	_.extend(base_model, LoadUtils.LoaderMixin, {
		// Convenience function used in unpack. Any keys in both the provided data
		// and the model defaults but not in the optional exclude_list parameter
		// will be transferred to the model.
		setFields: function (raw_data, exclude_list) {
			if (!raw_data) {
				return;
			}

			var raw_id = raw_data[this.id_attribute];
			if (!_.isUndefined(raw_id)) {
				this.id = this.nonnumeric_ids ? raw_id : parseInt(raw_id, 10);
			}

			// Do some typecasting and filtering before setting the data.
			// Use an auxiliary variable to hold the actual values to set.
			// (Backbone has lots of overhead if we do multiple set calls.)
			var set_data = {};
			_.each(
				raw_data,
				function (value, field) {
					var default_value = this.defaults[field];
					// Only fields in the defaults hash are considered.
					if (
						this.defaults.hasOwnProperty(field) &&
						!_.contains(exclude_list, field)
					) {
						// Convert numbers and booleans from strings so that we can
						// use === safely with the unpacked values. Assume the defaults hash
						// has the desired data type.
						if (_.isNumber(default_value)) {
							set_data[field] = parseFloat(value, 10);
						} else if (_.isBoolean(default_value)) {
							set_data[field] = !!value;
						} else {
							set_data[field] = value;
						}
					}
				},
				this
			);

			this.set(set_data);
		},

		// Almost always overridden, but this default works sometimes
		unpack: function (data) {
			if (!data) {
				return;
			}

			this.setFields(data);
		},
	});
	EbkMBase.BaseModel = Backbone.Model.extend(base_model);

	var base_coll = {};
	_.extend(base_coll, BbExtras.AutocreateMixin, {
		// Convenience function for unpacking an array as a collection. Assumes
		// the collection contains models with an unpack method.
		// If the passed data grabs the model id from a key other than 'id',
		// pass it as the second argument.
		unpackAll: function (array_data, id_attribute) {
			id_attribute = id_attribute || "id";

			// Note: We only want to do one call of add here. Backbone has lots of
			// overhead for separate add calls.
			var model_list = [];
			_.each(
				array_data || [],
				function (data) {
					var id = data[id_attribute];
					// Hold on adding the model so we can do it all at once.
					var model = this.getOrCreate(id, {delay_add: true});
					model.unpack(data);
					model_list.push(model);
				},
				this
			);

			// Delayed the add; do it all at once now.
			this.add(model_list);

			return model_list;
		},
	});
	EbkMBase.BaseCollection = Backbone.Collection.extend(base_coll);

	return EbkMBase;
})(AoPS.Ebooks.Models.Base);
